import { GET_WRITING_SURFACE_RECIPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WRITING_SURFACE_RECIPES_SUCCESS: {
      const writingSurfaceRecipes = action.payload;

      if (!writingSurfaceRecipes){
        return {...state};
      }


      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
